import { createElement } from 'react';
import { ScrollRankingBoard } from '@jiaminghi/data-view-react';
const DataVScrollRankingBoard = (props) => {
    const { style, ...rest } = props;
    const config = {
        ...rest,
    };
    return createElement(ScrollRankingBoard, { config: config, style: style });
};
export default DataVScrollRankingBoard;
